// frontend/src/pages/Advertisements.tsx
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

interface Advertisement {
  id: number;
  title: string;
  type: string;
  price: string | null;
  category: string;
  description: string;
  contact_phone: string;
  created_at: string;
  user_name?: string;
  status: string;
}

const Advertisements: React.FC = () => {
  const [ads, setAds] = useState<Advertisement[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    console.log('🔄 در حال بارگذاری آگهی‌ها...');
    
    fetch('https://fellfell.ir/api/advertisements.php', {
      credentials: 'include'
    })
      .then(response => {
        console.log('📦 پاسخ HTTP:', response.status);
        return response.json();
      })
      .then(data => {
        console.log('📦 داده‌های دریافت شده:', data);
        
        if (data.success && Array.isArray(data.data)) {
          console.log('✅ تعداد آگهی‌ها:', data.data.length);
          setAds(data.data);
        } else {
          setError('داده‌ها به درستی دریافت نشدند.');
          console.error('❌ ساختار داده‌ها نامعتبر است:', data);
        }
        setLoading(false);
      })
      .catch(err => {
        console.error('❌ خطا در بارگذاری آگهی‌ها:', err);
        setError('خطا در بارگذاری آگهی‌ها: ' + err.message);
        setLoading(false);
      });
  }, []);

  // ── تابع نمایش نوع آگهی ──────────────────────────────
  const getTypeLabel = (type: string) => {
    const types: Record<string, string> = {
      'sell': '🟢 فروش',
      'buy': '🔵 خرید',
      'request': '🟡 درخواست',
      'cooperation': '🟣 همکاری'
    };
    return types[type] || type;
  };

  // ── تابع نمایش وضعیت ──────────────────────────────────
  const getStatusLabel = (status: string) => {
    const statuses: Record<string, { label: string; color: string }> = {
      'active': { label: '✅ فعال', color: '#2e7d32' },
      'pending': { label: '⏳ در انتظار', color: '#f57c00' },
      'rejected': { label: '❌ رد شده', color: '#c62828' },
      'expired': { label: '⏰ منقضی', color: '#757575' }
    };
    return statuses[status] || { label: status, color: '#757575' };
  };

  if (loading) {
    return (
      <div className="loading" style={{ textAlign: 'center', padding: '50px' }}>
        ⏳ در حال بارگذاری آگهی‌ها...
      </div>
    );
  }

  if (error) {
    return (
      <div className="alert alert-error" style={{ padding: '20px', color: '#c62828', background: '#ffebee', borderRadius: '10px' }}>
        ❌ {error}
      </div>
    );
  }

  return (
    <>
      <div className="page-header" style={{ background: '#1e3a1e', color: '#fff', padding: '40px 0' }}>
        <div className="container" style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 20px' }}>
          <h1 style={{ fontSize: '28px' }}>📢 آگهی‌ها</h1>
          <p style={{ color: '#a5d6a7', marginTop: '5px' }}>لیست تمام آگهی‌های ثبت شده</p>
        </div>
      </div>
      
      <section style={{ padding: '30px 0' }}>
        <div className="container" style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 20px' }}>
          {ads.length === 0 ? (
            <div style={{ textAlign: 'center', padding: '60px 20px', background: '#fff', borderRadius: '16px', boxShadow: '0 2px 10px rgba(0,0,0,0.06)' }}>
              <div style={{ fontSize: '48px', marginBottom: '15px' }}>📭</div>
              <p style={{ fontSize: '18px', color: '#888' }}>هیچ آگهی‌ای ثبت نشده است</p>
              <p style={{ color: '#aaa', marginTop: '5px' }}>اولین آگهی را شما ثبت کنید!</p>
            </div>
          ) : (
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(320px, 1fr))', gap: '25px' }}>
              {ads.map(ad => {
                const statusInfo = getStatusLabel(ad.status || 'active');
                return (
                  <div 
                    key={ad.id} 
                    style={{ 
                      background: '#fff', 
                      borderRadius: '16px', 
                      padding: '20px', 
                      boxShadow: '0 4px 20px rgba(0,0,0,0.06)',
                      transition: 'transform 0.2s, box-shadow 0.2s',
                      cursor: 'pointer',
                      borderRight: `4px solid ${ad.status === 'active' ? '#2e7d32' : '#f57c00'}`
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = 'translateY(-4px)';
                      e.currentTarget.style.boxShadow = '0 8px 30px rgba(0,0,0,0.12)';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = 'translateY(0)';
                      e.currentTarget.style.boxShadow = '0 4px 20px rgba(0,0,0,0.06)';
                    }}
                  >
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                      <h3 style={{ margin: '0 0 8px 0', fontSize: '18px' }}>
                        <Link to={`/advertisement/${ad.id}`} style={{ color: '#1e3a1e', textDecoration: 'none' }}>
                          {ad.title}
                        </Link>
                      </h3>
                      <span style={{ fontSize: '12px', color: statusInfo.color, fontWeight: 'bold' }}>
                        {statusInfo.label}
                      </span>
                    </div>
                    
                    <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap', marginBottom: '10px' }}>
                      <span style={{ padding: '3px 12px', borderRadius: '20px', fontSize: '12px', background: '#e8f5e9', color: '#2e7d32' }}>
                        {getTypeLabel(ad.type)}
                      </span>
                      <span style={{ padding: '3px 12px', borderRadius: '20px', fontSize: '12px', background: '#e3f2fd', color: '#0d47a1' }}>
                        {ad.category || 'متفرقه'}
                      </span>
                    </div>
                    
                    <p style={{ color: '#555', fontSize: '14px', lineHeight: '1.6', margin: '8px 0' }}>
                      {ad.description?.substring(0, 120) || ''}...
                    </p>
                    
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '12px', borderTop: '1px solid #f0f0f0', paddingTop: '12px' }}>
                      <div>
                        {ad.price && (
                          <span style={{ fontWeight: 'bold', color: '#2e7d32' }}>
                            💰 {new Intl.NumberFormat('fa-IR').format(Number(ad.price))} تومان
                          </span>
                        )}
                        {!ad.price && <span style={{ color: '#888' }}>💰 توافقی</span>}
                      </div>
                      <div style={{ fontSize: '12px', color: '#888' }}>
                        📞 {ad.contact_phone}
                      </div>
                    </div>
                    
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '10px', fontSize: '12px', color: '#aaa' }}>
                      <span>👤 {ad.user_name || 'کاربر'}</span>
                      <span>📅 {new Date(ad.created_at).toLocaleDateString('fa-IR')}</span>
                    </div>
                    
                    <Link 
                      to={`/advertisement/${ad.id}`} 
                      style={{ 
                        display: 'inline-block', 
                        marginTop: '12px', 
                        padding: '8px 20px', 
                        background: '#2e7d32', 
                        color: '#fff', 
                        borderRadius: '8px', 
                        textDecoration: 'none',
                        fontSize: '14px',
                        fontWeight: '600'
                      }}
                    >
                      مشاهده جزئیات
                    </Link>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </section>
    </>
  );
};

export default Advertisements;